import { forwardRef } from "react";
import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import styles from "@/components/forms/inputs/defaultInput.module.css";

interface Props {
  mandatory?: boolean;
  label?: string;
  name?: string;
  infoTooltip?: boolean;
  infoTooltipMessage?: string | any;
  required?: boolean;
  onChange?: (event: any) => void;
  defaultValue?: string;
  autoComplete?: string;
  type?: string;
  min?: number | string;
  step?: number | string;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
  placeholder?: string;
  readonly?: boolean;
  value?: string;
  onFocus?: () => void;
  onBlur?: (event?: any) => void;
  width?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  inputClassName?: string;
  labelClassName?: string;
  accept?: any;
  children?: any;
  inputStyle?: any;
  labelStyle?: any;
}

const DefaultInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const defaultInputStyle = {
    display: "flex",
    flexDirection: "column",
    width: props.width ? props.width : "",
    ...props.style,
  } as React.CSSProperties;

  const textStyle = {
    border: "1px solid #bcbcbc",
    outline: "none",
    padding: "0.75rem",
    borderRadius: "0.75rem",
    ...props.inputStyle,
  } as React.CSSProperties;
  return (
    <label
      className={props.labelClassName ? props.labelClassName : ""}
      style={props.labelStyle ? props.labelStyle : defaultInputStyle}
      htmlFor={props.name}
    >
      <span>
        {props.mandatory === true ? (
          <span>
            {props.label}
            <span style={{ color: "red" }}> {`\u{002A}`}</span>
          </span>
        ) : (
          props.label
        )}
        {props.infoTooltip && (
          <Tooltip title={props.infoTooltipMessage} placement="right">
            <InfoIcon className={styles.infoIcon} />
          </Tooltip>
        )}
      </span>
      <input
        ref={ref}
        accept={props.accept}
        className={props.inputClassName}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        style={textStyle}
        id={props.name}
        required={props.required || props.mandatory}
        onChange={props.onChange}
        value={props.value}
        defaultValue={props.defaultValue}
        name={props.name}
        autoComplete={props.autoComplete}
        type={props.type}
        min={props.min}
        step={props.step}
        aria-invalid={props["aria-invalid"]}
        aria-describedby={props["aria-describedby"]}
        placeholder={props.placeholder}
        readOnly={props.readonly}
        disabled={props.disabled}
      />
      {props.children}
    </label>
  );
});

DefaultInput.displayName = "DefaultInput";

export default DefaultInput;
